import { useState, useEffect } from 'react';
import { differenceInSeconds, endOfMonth } from 'date-fns';

export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  }>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const end = endOfMonth(now);
      const diffInSeconds = differenceInSeconds(end, now);

      if (diffInSeconds > 0) {
        const days = Math.floor(diffInSeconds / (3600 * 24));
        const hours = Math.floor((diffInSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((diffInSeconds % 3600) / 60);
        const seconds = diffInSeconds % 60;

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  const TimeUnit = ({ value, label }: { value: number; label: string }) => (
    <div className="flex flex-col items-center mx-3 sm:mx-6 group">
      <div className="relative">
        <span className="text-4xl sm:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-b from-white to-white/50 tracking-tight tabular-nums group-hover:to-white transition-all duration-300">
          {value.toString().padStart(2, '0')}
        </span>
        {/* Subtle glow effect behind numbers */}
        <div className="absolute inset-0 bg-white/5 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>
      <span className="text-[10px] sm:text-xs font-medium uppercase tracking-[0.2em] text-zinc-500 mt-2 group-hover:text-zinc-400 transition-colors">
        {label}
      </span>
    </div>
  );

  return (
    <div className="flex items-center justify-center my-10 animate-fade-in">
      <TimeUnit value={timeLeft.days} label="Dias" />
      <div className="h-8 w-px bg-gradient-to-b from-transparent via-zinc-800 to-transparent" />
      <TimeUnit value={timeLeft.hours} label="Horas" />
      <div className="h-8 w-px bg-gradient-to-b from-transparent via-zinc-800 to-transparent" />
      <TimeUnit value={timeLeft.minutes} label="Min" />
      <div className="h-8 w-px bg-gradient-to-b from-transparent via-zinc-800 to-transparent" />
      <TimeUnit value={timeLeft.seconds} label="Seg" />
    </div>
  );
}
